import { createAxios } from '../lib/axiosFactory';
import { errorParser } from '../lib/response/errorParser';
import { ActionResponse } from '../lib/interfaces/actionResponse';

export const state = {
  previewHtml: '',
  manifest: {},
  contentChanges: {},
  contentSaveHandler: {}
};

export const mutations = {
  setName(state: any, { name }: { name: string }): void {
    state.name = name;
  },

  setPreviewHtml(state: any, { previewHtml }: { previewHtml: string }): void {
    state.previewHtml = previewHtml;
  },

  setManifest(state: any, manifest: any): void {
    state.manifest = { ...manifest };
  }
};
